module.exports = __webpack_public_path__ + "media/images/konintodoke/printout/3-6-aee112002325785af330369ee20fc405.png";